const INITIAL_STATE = {
  error: false,
  loading: false,
  data: []
};

const SearchPlatform = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SEARCH_PLATFORM_REQUEST":
      return { loading: true, error: false };
    case "SEARCH_PLATFORM_ERROR":
      return { loading: false, error: true };
    case "SEARCH_PLATFORM_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    case "SEARCH_PLATFORM_RESET":
      return { loading: false, error: false, data: [] };
    default:
      return state;
  }
};

export default SearchPlatform;
